import { render, staticRenderFns } from "./edit-floor.vue?vue&type=template&id=408ad9e8&"
import script from "./edit-floor.vue?vue&type=script&lang=ts&"
export * from "./edit-floor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports